// extracted by mini-css-extract-plugin
export var intro = "style-module--intro--529bf";
export var subMenu = "style-module--subMenu--3632f";
export var subText = "style-module--subText--dd14e";